import * as React from 'react';

import { ButtonVariant } from './DeprecatedButton';
import { classNameForLinkButtonProps } from '../../utils/linkButtonUtils';

export interface ILinkButton {
  className?: string;
  title?: string;
  'data-testid'?: string;
  disabled?: boolean;
  modifierClassName?: string;
  onPointerDown?(event: React.PointerEvent<HTMLElement>): void;
  onClick?(event: React.MouseEvent<HTMLElement>): void;
  shape?: 'rounded';
  size?: 'small' | 'medium' | 'large';
  variant: ButtonVariant | 'default';
}

interface Props extends ILinkButton {
  children: string | JSX.Element | JSX.Element[] | React.ReactNode;
  type?: 'button' | 'submit';
}

/**
 * A button that looks like a link
 */
export default class LinkButton extends React.PureComponent<Props> {
  static defaultProps: Partial<Props> = {
    type: 'button',
  };

  render() {
    const {
      children,

      disabled,
      type,
      onPointerDown,
      onClick,
      className,
      modifierClassName,
      variant,
      size,
      title,
      ...rest
    } = this.props;

    return (
      <button
        className={classNameForLinkButtonProps(this.props)}
        disabled={disabled}
        title={title}
        type={type}
        data-testid={this.props['data-testid']}
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        onPointerDown={onPointerDown!}
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        onClick={onClick!}
        {...rest}
      >
        <div className="LinkButton-content">{children}</div>
      </button>
    );
  }
}
